module.exports = __webpack_public_path__ + "static/img/icon_19.12b0eb8.png";


//////////////////
// WEBPACK FOOTER
// ./static/otherpage/icon_19.png
// module id = q0Jb
// module chunks = 1